import React from "react";
import FormElement from "Components/Core/Form/FormElement";
import NewPosting from 'Components/Forum/NewPosting';
import PostingContextMenu from "./PostingContextMenu";
import FormSelectText from 'Components/Core/Form/FormSelectText';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';


export default function NewAnswer(props) {

    const x = props.x;
	const [update, setUpdate] = React.useState(Date.now());
	const selectTopicId = props.moduleId + '-select-set-topic';
	const postingBackup = React.useRef('');

	function editPosting() {
		if (x.waf.isReadOnly(props.dialogId, 'base-posting')) {
			postingBackup.current = x.waf.get(props.dialogId, 'base-posting');
			x.waf.setReadOnly(props.dialogId, 'base-posting', false);
			// x.waf.focus(props.dialogId, 'base-posting');
			x.waf.setCursorPos(props.dialogId, 'base-posting', 0, 0)
		}
		else {
			x.waf.setReadOnly(props.dialogId, 'base-posting', true);
		}
	}

	function postingSaveEdit() {
		x.waf.setReadOnly(props.dialogId, 'base-posting', true);
		const fields = {};
		fields['posting'] = x.waf.get(props.dialogId, 'base-posting');
		fields['postingBackup'] = postingBackup.current;
		x.was.axPost('/Backend/webapp.php?module=Posting&task=PostingUpdate&postingNo=' + props.answerTo, fields, (result) => {
			if (result.data['returncode'] === 1) {
				// x.wah.addHint('Thema zugewiesen...', true)
				x.wam[props.moduleId].reload();
				x.was.send('new-posting', { "module": props.moduleId, "member": x.was.memberName, "memberlevel": x.was.memberLevel, "postingno": -1 });

			}
		});
	}

	function postingCancelEdit() {
		x.waf.set(props.dialogId, 'base-posting', postingBackup.current);
		x.waf.setReadOnly(props.dialogId, 'base-posting', true);
		
	}
	function getTopicList() {
		const topicList = [{'id': 0, 'name': 'Kein Thema zuordnen'}].concat(x.was.topics);
		return topicList;			
	}

	function saveTopicId(topicId) {
		x.was.axGet('/Backend/webapp.php?module=Posting&task=SavePostingTopic&postingNo=' + props.answerTo + '&topicId=' + topicId, (result) => {
			if (result.data['returncode'] === 1) {
				// x.wah.addHint('Thema zugewiesen...', true)
				x.wam[props.moduleId].reload();
			}
		});
	}

	return (
		<React.Fragment key={props.moduleId + '-div-answer'}>
			<NewPosting
				x={x}  
				id={props.moduleId + '-answer'}
				memberRef={props.memberRef}
				newPostingFunctions={props.newPostingFunctions}
				showDialogAnswer={props.showDialogAnswer}
				key={props.moduleId + "-new-posting"}
				titleText='Antwort: '
				moduleId={props.moduleId}
				forumId={props.forumId}
				answerTo={props.answerTo}
				dialogId={props.dialogId}
			>
				<PostingContextMenu
					x={x}  
					moduleId={props.moduleId}
					forumId={props.forumId}
					dialogId={props.dialogId}
					answerTo={props.answerTo}
					registerDialog={props.registerDialog}
					postingQuote={props.postingQuote}
					copyToClipboard={props.copyToClipboard}
					editPosting={editPosting}
					postingSaveEdit={postingSaveEdit}
					postingCancelEdit={postingCancelEdit}
				/>
				<div className="select-topic">
					<FormSelectText
						id={selectTopicId}
						iconMode={false}
						wafId={props.moduleId + "-form-current-topic"}
						name="topicid"
						componentId={x.wau.getComponentId()}
						moduleId={props.id}
						x={x}  
						disabled={(x.wad[props.dialogId].memberId === x.was.memberId || x.was.isAdmin()) ? false : true}
						title={(x.wad[props.dialogId].memberId === x.was.memberId || x.was.isAdmin()) ? "Diesem Beitrag ein Thema zuweisen." : "Kein Thema zugewiesen..."}
						alwaysShowSelection={false}
						afterSelect={(key, value) => {
							saveTopicId(key);

						}}
						resetIcon={false}

					/>
				</div>
				<div className="answer-to-textarea">
					<FormElement
						type="textarea"
						x={x}  
						dialogId={props.dialogId}
						wafId={props.dialogId}
						id="base-posting"
						readOnly={true}
						name="body"
						title=""
						fieldValue=""
						rows="8"
						update={update}
						onChange={() => {
							setUpdate(Date.now());
						}} 
					/>
				</div>
				<DialogSelectText 
					id={selectTopicId} 
					moduleId={props.id} 
					x={x}
					classes="dialog-select-topics"   
					onSetData={getTopicList} 
					title="Thema" 
				/>
			</NewPosting>
		</React.Fragment >
	)

}